import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise';
import Promise from 'bluebird';
import moment from 'moment';
import config from './config';
import rootReducer from './reducer/rootReducer';
import AdIdGenerator from './util/adIdGenerator';
import reduxPromiseRejectLogger from './util/redux-promise-reject-logger';
import translateGenerator from './util/translateGenerator';

const { NODE_ENV } = config;

const middlewares = [
  promiseMiddleware,
  reduxPromiseRejectLogger,
];

if (NODE_ENV !== 'production') {
  Promise.config({
    longStackTraces: true,
  });
}

export function instantiateStore(initialState) {
  return compose(
    applyMiddleware(...middlewares),
    typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : f => f
  )(createStore)(rootReducer, initialState);
}

export function createApp(storeState) {
  const t = translateGenerator(storeState.language);
  const store = instantiateStore(storeState);
  const adIdGenerator = new AdIdGenerator();

  // this is so we don't have to rely on the client clock being correct
  // NOTE: due to caching the serverTime can be wrong by a couple of minutes,
  // so don't rely on the time being exactly correct
  const serverOffset = moment(storeState.serverTime).diff(Date.now());
  const serverTime = () => moment().add(serverOffset, 'milliseconds');

  return {
    store,
    adIdGenerator,
    t,
    serverTime,
  };
}



// WEBPACK FOOTER //
// ./src/app.js